module.exports = __webpack_public_path__ + "static/media/bib-fortuna.53b5a767.jpg";